export function formatQuestion(question) {
    let oQuestion = {
        ...question
    };
    oQuestion.content = JSON.parse(oQuestion.content);
    switch (oQuestion.questionTypeId) {
        case 2:
            oQuestion.answer = oQuestion.answer.split('');
            break;
        case 4:
            oQuestion.answer = oQuestion.answer.split(',');
            break;
        default:
            break;
    }
    return oQuestion;
}

export function formatQuestions(questions) {
    let arrQuestion = questions;
    if (typeof questions === 'string') {
        arrQuestion = JSON.parse(questions);
    }
    arrQuestion.map((item, i) => {
        arrQuestion[i] = formatQuestion(item);
    });
    return arrQuestion;
}

export function formatAnswerSheet(answerSheet) {
    let userAnswer = {};
    let arrUAnswer = [];
    let aSheet = JSON.parse(answerSheet) || [];
    let {
        answerSheetItems
    } = aSheet;
    answerSheetItems.map(item => {
        let {
            answer
        } = item;
        switch (item.questionTypeId) {
            case 2:
                answer = answer.split('');
                break;
            case 4:
                answer = answer.split(',');
                break;
            default:
                break;
        }
        arrUAnswer.push({
            ...item,
            answer
        });
    });
    userAnswer = {
        ...aSheet,
        answerSheetItems: arrUAnswer
    };
    return userAnswer;
}

export function formatPractice(practice) {
    let practiceRow = {};
    let {
        answerSheet,
        content
    } = practice;
    answerSheet = JSON.parse(answerSheet);
    content = JSON.parse(content);
    let questionList = [];
    let {
        answerSheetItems
    } = answerSheet;
    content.map((item, index) => {
        let questionTypeText = '';
        let curQuestion = answerSheetItems.filter(q => {
            return q.questionId === item.questionId;
        });
        let {
            answer,
            right
        } = curQuestion[0];
        switch (item.questionTypeId) {
            case 1:
                questionTypeText = '单选题';
                break;
            case 2:
                questionTypeText = '多选题';
                answer = answer.split('');
                break;
            case 3:
                questionTypeText = '判断题';
                break;
            case 4:
                questionTypeText = '填空题';
                answer = answer.split(',');
                break;
            case 5:
                questionTypeText = '简答题';
                break;
            case 6:
                questionTypeText = '论述题';
                break;
            case 7:
                questionTypeText = '分析题';
                break;
            default:
                questionTypeText = '未知题型';
                break;
        }
        questionList.push({
            ...item,
            content: JSON.parse(item.content),
            questionIndex: index,
            questionTypeText,
            userAnswer: answer,
            right
        });
    });
    practiceRow = {
        ...practice,
        answerSheet,
        content: questionList
    };
    return practiceRow;
}

/**
 * 数组乱序
 * @param {Array} arr1 需要操作的数组
 */
export function disorder(arr1) {
    let arr2 = [];
    while (arr1.length > 0) {
        let index = Math.floor(Math.random() * arr1.length);
        arr2.push(arr1[index]);
        arr1.splice(index, 1);
    }
    return arr2;
}